import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>

    <App />
    <a href="https://api.whatsapp.com/send?phone=3316956952&text=Hola%21%20BienVivir." class="whatsapp-button-float" target="_blank">
      <i class="fa fa-whatsapp my-whatsapp-button-float"></i> 
    </a>
  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
